import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import { useNavigate } from 'react-router-dom';

const bodyBenefits = [
  {
    icon: 'ri-pulse-line',
    title: '穩定血壓',
    desc: '研究顯示，身處森林環境中，人體嘅收縮壓同舒張壓都會顯著下降。樹木環繞嘅綠色空間能自然地讓血管放鬆、血液循環更順暢，為長期受高壓困擾嘅都市人提供一個天然嘅降壓方法。',
  },
  {
    icon: 'ri-plant-line',
    title: '自然芬多精',
    desc: '樹木會釋放名為「芬多精」嘅有機化合物。吸入佢哋能顯著增加體內「自然殺手細胞 (NK cells)」嘅活性，從而增強人體免疫系統，幫助防癌與抗發炎。',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: '降低壓力荷爾蒙 (Cortisol)',
    desc: '皮膚直接或近距離接觸大自然（如抱樹、觸摸樹皮），能即時降低體內嘅皮質醇（壓力荷爾蒙）水平，減緩心率，並使自律神經系統（交感與副交感神經）回復平衡。',
  },
  {
    icon: 'ri-hand-heart-line',
    title: '釋放催產素 (Oxytocin)',
    desc: '「擁抱」呢個動作（不論對人或對樹）能刺激大腦釋放催產素（又稱擁抱荷爾蒙）。呢種荷爾蒙能產生安全感、信任感，並有效減輕身體嘅慢性疼痛與發炎反應。',
  },
];

const mindBenefits = [
  {
    icon: 'ri-emotion-happy-line',
    title: '穩定情緒',
    desc: '身處充滿大自然樹木的環境中，能有效降低壓力荷爾蒙，發揮天然的情緒穩定作用。當壓力荷爾蒙回落，大腦會分泌更多血清素（Serotonin）——呢種「快樂荷爾蒙」有助穩定情緒、減輕抑鬱感同提升整體幸福感。',
  },
  {
    icon: 'ri-earth-line',
    title: 'Grounding 接地感',
    desc: 'Grounding（接地）就係身體同大自然嘅實體連結——赤腳踩草地、或者用手觸摸樹幹樹皮。當肌膚接觸到泥土同樹木，身體會收到一個清晰嘅訊號「你喺呢度、你係安全嘅」，神經系統嘅過度警覺會慢慢降溫，亂糟糟嘅思緒亦會重新落返嚟、錨定喺當下呢一刻。',
  },
  {
    icon: 'ri-hand-heart-line',
    title: '無條件的接納',
    desc: '樹木永遠不會評判你。無論你心中承載著怎樣的情緒、委屈或焦慮，你都可以放心地將這些重擔交給它，它會安靜而溫柔地接納你的一切。',
  },
  {
    icon: 'ri-plant-line',
    title: '能量交換',
    desc: '樹木以好緩慢嘅頻率震動，呢個頻率好接近人冥想嗰陣嘅深度放鬆波段。抱樹嘅時候，你嘅腦波自然會跟住慢落嚟——唔使刻意冥想，身體自己會跟。',
  },
];

export default function Benefits() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />
      <main>
        <section className="relative py-20 md:py-24 bg-background-50">
          <div className="max-w-7xl mx-auto px-6 md:px-10">
            <button
              type="button"
              onClick={() => navigate('/')}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-100 hover:bg-background-200 text-sm font-medium text-foreground-600 transition-colors cursor-pointer whitespace-nowrap mb-10"
            >
              <i className="ri-arrow-left-line"></i>
              返回主頁
            </button>

            <div className="text-center max-w-3xl mx-auto mb-16">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-800 text-xs font-semibold tracking-widest uppercase mb-6 whitespace-nowrap">
                <i className="ri-leaf-line"></i>
                身心同步 · Body &amp; Mind
              </div>
              <h2 className="font-heading text-3xl md:text-5xl font-medium text-foreground-950 leading-tight whitespace-nowrap">
                點解抱樹會有效？
              </h2>
              <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg mx-auto">
                用身體語言同大自然嘅智慧，一齊探索抱樹點樣溫柔咁照顧你——由外到內。
              </p>
            </div>

            {/* 對身體的好處 */}
            <div className="mb-10">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500 text-background-50">
                  <i className="ri-heart-pulse-line text-lg"></i>
                </div>
                <h3 className="font-heading text-2xl md:text-3xl font-medium text-foreground-950">
                  對身體的好處
                </h3>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                {bodyBenefits.map((b) => (
                  <div key={b.title} className="flex flex-col gap-4 p-5 rounded-2xl bg-background-100 border border-primary-100/60">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-50 text-primary-600 shrink-0">
                      <i className={`${b.icon} text-lg`}></i>
                    </div>
                    <div>
                      <h4 className="text-base font-semibold text-foreground-900">{b.title}</h4>
                      <p className="mt-1.5 text-sm text-foreground-700 leading-relaxed">{b.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* 對心靈的好處 */}
            <div className="mb-16">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-500 text-background-50">
                  <i className="ri-sparkling-line text-lg"></i>
                </div>
                <h3 className="font-heading text-2xl md:text-3xl font-medium text-foreground-950">
                  對心靈的好處
                </h3>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {mindBenefits.map((b) => (
                  <div key={b.title} className="flex gap-4 p-5 rounded-2xl bg-background-100 border border-secondary-100/60">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-50 text-secondary-600 shrink-0">
                      <i className={`${b.icon} text-lg`}></i>
                    </div>
                    <div>
                      <h4 className="text-base font-semibold text-foreground-900">{b.title}</h4>
                      <p className="mt-1.5 text-sm text-foreground-700 leading-relaxed">{b.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* 關於樹：植物的智慧與連結 */}
            <div className="border-t border-background-200/70 pt-16">
              <div className="text-center max-w-2xl mx-auto mb-12">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100/80 text-accent-800 text-xs font-semibold tracking-widest uppercase mb-5 whitespace-nowrap">
                  <i className="ri-seedling-line"></i>
                  Tree Wisdom · 樹木智慧
                </div>
                <h3 className="font-heading text-2xl md:text-3xl font-medium text-foreground-950 leading-tight">
                  關於樹：植物的智慧與連結
                </h3>
                <p className="mt-4 text-sm md:text-base text-foreground-500 leading-relaxed">
                  樹木唔單止係風景——佢哋擁有我哋想像唔到嘅智慧同社群。了解佢哋點樣生活，你或者會發現，抱住一棵樹嘅時候，你連接嘅係一個遠比你想像中更宏大嘅生命網絡。
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
                {/* Card 1: Wood Wide Web */}
                <div className="rounded-2xl bg-background-100 border border-primary-100/60 overflow-hidden">
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=An%20artistic%20abstract%20macro%20photography%20of%20white%20fungal%20mycelium%20network%20threads%20spreading%20through%20dark%20rich%20forest%20soil%2C%20delicate%20thin%20hyphae%20connecting%20like%20a%20natural%20underground%20internet%2C%20soft%20diffused%20light%2C%20organic%20textures%2C%20scientific%20yet%20artistic%20aesthetic%2C%20warm%20earthy%20amber%20and%20cream%20tones&width=800&height=500&seq=tree-wisdom-mycelium&orientation=landscape"
                      alt="真菌網絡在森林土壤中連結樹根"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-2 mb-3">
                      <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600">
                        <i className="ri-git-branch-line"></i>
                      </div>
                      <h4 className="font-heading text-base font-semibold text-foreground-900">
                        樹木之間會溝通：Wood Wide Web
                      </h4>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      森林地下有一個由真菌菌絲編織而成嘅龐大網絡，科學家叫佢做「Wood Wide Web」。透過呢個網絡，樹木可以傳送養分俾生病嘅鄰居、發出害蟲警報、甚至將糖分傳俾年幼嘅樹苗。一棵母樹可以透過呢個地下網絡，同時養住周圍幾十棵唔同種類嘅小樹——呢個唔係競爭，係一個互相扶持嘅社群。
                    </p>
                    <div className="mt-4 p-4 rounded-xl bg-primary-50/60 border border-primary-100/50">
                      <p className="text-xs text-foreground-500 leading-relaxed">
                        <span className="font-semibold text-foreground-700">對你嘅啟發：</span>
                        當你抱住一棵樹嘅時候，你連接嘅唔係一個孤獨嘅個體，而係一整個互相關懷嘅生命網絡。你嘅孤獨感喺呢個網絡面前，會自然咁被承接同轉化——因為你本來就係呢個連結嘅一部分。
                      </p>
                    </div>
                  </div>
                </div>

                {/* Card 2: Chemical Signaling */}
                <div className="rounded-2xl bg-background-100 border border-accent-100/60 overflow-hidden">
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=A%20closeup%20nature%20photograph%20of%20a%20tree%20trunk%20with%20one%20fresh%20green%20leaf%20and%20one%20slightly%20damaged%20yellowing%20leaf%20side%20by%20side%2C%20soft%20morning%20dew%20droplets%20on%20the%20surface%2C%20warm%20natural%20sunlight%20filtering%20through%20forest%20canopy%2C%20shallow%20depth%20of%20field%2C%20organic%20textures%2C%20subtle%20golden%20green%20tones%2C%20meditative%20botanical%20aesthetic&width=800&height=500&seq=tree-wisdom-signals&orientation=landscape"
                      alt="樹葉釋放化學訊號互相溝通"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-2 mb-3">
                      <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-50 text-accent-600">
                        <i className="ri-broadcast-line"></i>
                      </div>
                      <h4 className="font-heading text-base font-semibold text-foreground-900">
                        化學訊號：樹木嘅語言系統
                      </h4>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      當一棵樹被昆蟲攻擊嘅時候，佢會即時釋放揮發性化學物質（VOCs）到空氣中。呢啲化學訊號隨風飄散，被附近嘅樹木「聞到」之後，佢哋會即刻啟動自身嘅防禦系統——產生驅蟲物質、讓葉片變得難食。更神奇嘅係，唔同樹種之間都可以解讀對方嘅化學語言，跨物種協作防禦。
                    </p>
                    <div className="mt-4 p-4 rounded-xl bg-accent-50/60 border border-accent-100/50">
                      <p className="text-xs text-foreground-500 leading-relaxed">
                        <span className="font-semibold text-foreground-700">對你嘅啟發：</span>
                        樹木喺面對危機嘅時候，唔會淨係保護自己——佢會發出警報俾周圍嘅同伴。抱樹嘅時候，你吸入嘅唔止係清新空氣，仲有樹木釋放嘅芬多精——呢啲化學物質同時可以鎮靜你嘅神經系統，令你嘅身體由「戰鬥模式」切換到「放鬆模式」。
                      </p>
                    </div>
                  </div>
                </div>

                {/* Card 3: Self-healing */}
                <div className="rounded-2xl bg-background-100 border border-secondary-100/60 overflow-hidden">
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=A%20detailed%20closeup%20nature%20photography%20of%20a%20tree%20trunk%20showing%20natural%20healed%20scar%20tissue%20where%20a%20branch%20was%20lost%2C%20smooth%20callus%20wood%20growing%20over%20the%20old%20wound%2C%20beautiful%20organic%20patterns%20of%20bark%20regeneration%2C%20soft%20golden%20side%20lighting%2C%20textured%20brown%20and%20green%20tones%2C%20resilient%20healing%20aesthetic%2C%20documentary%20botanical%20style&width=800&height=500&seq=tree-wisdom-healing&orientation=landscape"
                      alt="樹幹上癒合嘅傷疤組織"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-2 mb-3">
                      <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-50 text-secondary-600">
                        <i className="ri-heart-pulse-line"></i>
                      </div>
                      <h4 className="font-heading text-base font-semibold text-foreground-900">
                        自我修復：樹木嘅自癒機制
                      </h4>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      當樹木受傷——被雷劈、被動物咬、或者斷枝——佢唔會「醫返好」受傷嘅組織，而係用一種叫「區隔化」（Compartmentalization）嘅方式：喺傷口周圍生成新嘅保護層，將受傷部分封鎖隔離，然後繼續向外生長新嘅健康組織。樹木唔會執著喺修復舊傷口，而係選擇喺傷口旁邊重新出發。
                    </p>
                    <div className="mt-4 p-4 rounded-xl bg-secondary-50/60 border border-secondary-100/50">
                      <p className="text-xs text-foreground-500 leading-relaxed">
                        <span className="font-semibold text-foreground-700">對你嘅啟發：</span>
                        樹木教曉我哋：療癒唔係要將傷口變返「完好無缺」，而係學識同傷口共存，繼續向前生長。抱樹嘅時候，你觸摸到嘅樹皮上面可能有歲月留低嘅疤痕——但棵樹仍然企喺度、仍然綠葉滿枝。你嘅傷口，亦都可以成為你生命入面獨特嘅紋理，唔會阻礙你繼續盛放。
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Closing reflection */}
              <div className="mt-12 max-w-2xl mx-auto text-center">
                <div className="p-6 rounded-2xl bg-background-100 border border-background-200/60">
                  <i className="ri-double-quotes-l text-3xl text-primary-300 mb-3 block"></i>
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                    當你知道一棵樹背後有咁多智慧同連結之後，下次你再攬住佢嘅時候，你可能會感受到——你攬緊嘅唔單止係一棵樹，而係一個活生生、有感情、有記憶、有社群嘅生命體。而你，本身就係呢個生命網絡嘅一部分。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}